<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('lead.breadcrumb')" :title="$t('lead.queueTitle')">
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div v-if="false" class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.id" placeholder="ID" />
        </div>
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.email" placeholder="Email" />
        </div>
        <div class="list__filter-item">
          <input type="text" v-model="filterData.first_name" placeholder="First Name" />
        </div>
        <div class="list__filter-item">
          <input type="text" v-model="filterData.last_name" placeholder="Last Name" />
        </div>
        <div class="list__filter-item">
          <input type="text" v-model="filterData.phone" placeholder="Phone" />
        </div>
        <div class="list__filter-item">
          <MainSelect
            :id="'country'"
            :placeholder="'Country'"
            :option-list="countryList"
            :set-value="filterData"
            :value="filterData.country"
            :labelName="'enName'"
          />
        </div>
        <div class="list__filter-item">
          <MainSelect
            :id="'language_id'"
            :placeholder="'Language'"
            :option-list="languagesList"
            :set-value="filterData"
            :value="filterData.language_id"
            :labelName="'code'"
          />
        </div>
        <div class="list__filter-item">
          <input
            type="text"
            v-model="filterData.campaign_internal"
            placeholder="campaign internal"
          />
        </div>
        <div v-if="admin" class="list__filter-item">
          <MainSelect
            :id="'integration'"
            :placeholder="'Integration'"
            :option-list="integrationList"
            :set-value="filterData"
            :value="filterData.integration"
            :labelName="'name'"
          />
        </div>

        <div class="list__filter-item">
          <MainSelect
            :id="'status'"
            :placeholder="'Status'"
            :option-list="statusList"
            :set-value="filterData"
            :value="filterData.status"
            :labelName="'name'"
          />
        </div>
        <div class="list__filter-item">
          <MainSelect
            :id="'deposit'"
            :placeholder="'FTD'"
            :option-list="depositList"
            :set-value="filterData"
            :value="filterData.deposit"
            :labelName="'name'"
          />
        </div>
        <div class="list__filter-item">
          <MainSelect
            :id="'buyer'"
            :placeholder="'Buyer'"
            :option-list="buyerList"
            :set-value="filterData"
            :value="filterData.buyer"
            :labelName="'email'"
          />
        </div>
        <div class="list__filter-item">
          <MainSelect
            :id="'team'"
            :placeholder="'Team'"
            :option-list="teamList"
            :set-value="filterData"
            :value="filterData.team"
            :labelName="'name'"
          />
        </div>
        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.created_at_from" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.created_at_to" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="exportLead()">Export</MainButton>
        </div>
      </div>
      <div class="list">
        <div v-if="leadsList.length">
          <CustomTable
            v-if="leadsList.length"
            :data="leadsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :noSortColumn="tableOptions.noSortColumn"
            :handleButtonReimport="reimport"
            :order="orderSort"
            :name="'lead-jobs'"
          >
          </CustomTable>
          <div class="pagination">
            <div class="list__per-page">
              <div
                v-for="(item, index) in perPageList"
                @click="changePerPage(item)"
                :key="index"
                :class="['list__per-page-item', item == perPage && 'active']"
              >
                {{ item }}
              </div>
            </div>
            <Pagination
              :maxPage="leads.lastPage"
              :page="page"
              :urlList="'LEAD_JOBS'"
              :totalItem="leads.total"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No leads found by this parameter.</div>
      </div>
    </ContentContainer>
    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal
      class="delete"
      v-if="deleteModal"
      :on-close="handleCloseConfirmModal"
      :modal-center="true"
    >
      <div class="list__confirm">
        <div class="list__confirm-title">Do you want to delete the Lead - {{ deleteRow.id }}?</div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal class="success" v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">
        Integrations {{ deleteRow.name }} successfully deleted.
      </div>
    </MainModal>

    <MainModal v-if="detailModal" :on-close="handleCloseDetailModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-column">
          <div class="list__confirm-title">Detail #{{ chosenLead.id }}</div>

          <div class="list__modal-list">
            <div class="list__modal-list-item"><b>Phone:</b> {{ chosenLead.phone }}</div>
            <div class="list__modal-list-item">
              <b>Campaign External:</b> {{ chosenLead.campaignExternal }}
            </div>
            <div class="list__modal-list-item">
              <b>Referrer Url:</b> {{ chosenLead.referrerUrl }}
            </div>
            <div class="list__modal-list-item"><b>Domain:</b> {{ chosenLead.domain }}</div>
            <div class="list__modal-list-item">
              <b>Processing Error:</b> {{ chosenLead.processingError }}
            </div>
            <div class="list__modal-list-item">
              <b>Fake Email:</b> {{ chosenLead.isFakeEmail ? "YES" : "NO" }}
            </div>
            <div class="list__modal-list-item"><b>Lang:</b> {{ chosenLead.lang }}</div>
          </div>

          <div
            v-if="
              admin &&
              (chosenLead.status.techName == 'error' ||
                chosenLead.status.techName == 'no_integration_available' ||
                chosenLead.status.techName == 'error_duplicate' ||
                chosenLead.status.techName == 'duplicate' ||
                !queue)
            "
            class="list__modal-send"
          >
            <div class="list__modal-sent-title">{{ $t("lead.assignManually") }}</div>

            <MainSelect
              :id="'integration'"
              :placeholder="'Integration'"
              :option-list="integrationAvailable"
              :set-value="sendData"
              :value="sendData.integration"
              :labelName="'name'"
            />

            <div class="list__modal-sent-button">
              <MainButton @click.native="sendLead()">{{ $t("common.send") }}</MainButton>
            </div>
          </div>
        </div>

        <div v-if="admin" class="list__confirm-column">
          <div class="list__confirm-title">Log List</div>

          <div v-for="(log, index) in logList" :key="log.id" class="list__modal-log">
            <div class="list__modal-log-top">
              <div class="list__modal-log-type">{{ log.log_type }}:{{ log.log_event }}</div>
              <div class="list__modal-log-date">
                {{ formatDate(log.log_created_at) }}
              </div>
              <div class="list__modal-log-status">{{ getStatusLog(log.status_id) }}</div>
            </div>
            <div v-if="log.integration_id" class="list__modal-log-integration">
              Integration id: {{ log.integration_id }}
            </div>
            <div v-if="log.message" class="list__modal-log-integration">
              Message: {{ log.message }}
            </div>
            <div v-if="log.error_message" class="list__modal-log-integration">
              Error Message: {{ log.error_message }}
            </div>
            <div v-if="log.response_body" class="list__modal-log-integration">
              Response: {{ log.response_body }}
            </div>

            <div
              @click="handleLogDetail(index, false)"
              v-if="log.is_detail"
              class="list__modal-log-detail-button"
            >
              See less
            </div>
            <div
              @click="handleLogDetail(index, true)"
              v-if="!log.is_detail"
              class="list__modal-log-detail-button"
            >
              See more
            </div>

            <div v-if="log.is_detail" class="list__modal-log-detail">
              <pre>{{ log }}</pre>
            </div>
          </div>
        </div>
      </div>
    </MainModal>

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import userApi from "~/api/user";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import keysToSnakeCase from "snakecase-keys";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";

export default {
  name: "LeadList",
  metaInfo: {
    title: "Leads List",
  },
  data() {
    return {
      admin: false,
      team_lead: false,
      bayer: false,
      canDelete: false,

      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",
      perPage: 20,
      perPageList: [20, 40, 60, 80, 100],

      detailModal: false,
      chosenLead: null,
      distribution_log: null,
      logStatus: [],
      logList: [],

      filterData: {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        integration: null,
        country: null,
        status: null,
        campaign_internal: "",
        created_at_from: null,
        created_at_to: null,
        language_id: null,
        deposit: null,
        buyer: null,
        team: null,
      },
      isFilter: false,
      countryList: [],
      statusList: [],
      integrationList: [],
      integrationAvailable: [],
      languagesList: [],
      buyerList: [],
      teamList: [],
      depositList: [
        {
          name: "All",
          id: "all",
        },
        {
          name: "Yes",
          id: "1",
        },
        {
          name: "No",
          id: "0",
        },
      ],
      sendData: {
        integration: null,
      },

      tableOptions: {
        deletedKeys: ["null"],
        noSortColumn: ["deposit", "is_duplicate", "queue"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
        ],
        customOrder: [
          "id",
          "lead_id",
          "client_id",
          "distribution_id",
          "integration_id",
          "deposit",
          "is_duplicate",
          "queue",
          "created_at",
          "available_at",
          "null",
        ],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
    MainSelect,
    DatePicker,
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }

      if (this.user.groups[0].id == 2 || this.user.groups[0].id == 5) {
        this.canDelete = true;
      }
    }

    if (this.admin) {
      // this.getIntegrationAll();
    }

    this.getList();
    // this.getLogStatus();
    // this.getCountry();
    // this.getLeadStatus();
    // this.getIntegrationAvailable();
    // this.getLanguage();
    // this.getBuyer();
    // this.getTeam();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "leads", "leadsList"]),
    ...mapState("lead", ["queue"]),
    page() {
      if (this.$route.params.page) {
        return +this.$route.params.page;
      } else {
        return 1;
      }
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },
    toSnakeCase(data) {
      return keysToSnakeCase(data, { deep: true });
    },
    async getCountry() {
      await leadApi
        .getCountryList()
        .then((res) => {
          this.countryList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getLeadStatus() {
      await leadApi
        .getLeadStatus()
        .then((res) => {
          this.statusList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getIntegrationAll() {
      await leadApi
        .getIntegrationAll()
        .then((res) => {
          this.integrationList = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getIntegrationAvailable() {
      await leadApi
        .getIntegrationListAvailable()
        .then((res) => {
          this.integrationAvailable = Object.values(res.data);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getBuyer() {
      await userApi
        .getBayerAll()
        .then((res) => {
          this.buyerList = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getTeam() {
      await userApi
        .getTeamAll()
        .then((res) => {
          this.teamList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async sendLead() {
      this.$store.commit("lead/setLoading", true);
      if (this.sendData.integration && this.chosenLead) {
        const data = {};
        data.lead_id = this.chosenLead.id;
        data.integration_id = this.sendData.integration.id;
        data.client_id = this.sendData.integration.clientId;
        await leadApi
          .sendLead(data)
          .then((res) => {
            this.$store.commit("lead/setLoading", false);
          })
          .catch((error) => {
            this.$store.commit("lead/setLoading", false);
          })
          .finally(() => {});
      }
    },
    getStatusLog(id) {
      const name = this.logStatus.find((i) => {
        return i.id == id;
      });

      if (name) {
        return name.name;
      }
    },
    getList() {
      let url = `?page=${this.page}&perPage=${this.perPage}&with[0]=country&with[1]=integration&with[2]=status&with[3]=deposit`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }
      if (this.isFilter) {
        const data = {
          parameters: {},
        };

        if (this.filterData.id.length) {
          data.parameters.id = this.filterData.id;
        }

        if (this.filterData.first_name.length) {
          data.parameters.first_name = this.filterData.first_name;
        }

        if (this.filterData.last_name.length) {
          data.parameters.last_name = this.filterData.last_name;
        }

        if (this.filterData.email.length) {
          data.parameters.email = this.filterData.email;
        }

        if (this.filterData.campaign_internal.length) {
          data.parameters.campaign_internal = this.filterData.campaign_internal;
        }

        if (this.filterData.integration) {
          data.parameters.integration_id = this.filterData.integration.id;
        }

        if (this.filterData.country) {
          data.parameters.country_id = this.filterData.country.id;
        }

        if (this.filterData.language_id) {
          data.parameters.language_id = this.filterData.language_id.id;
        }

        if (this.filterData.phone.length) {
          data.parameters.phone = this.filterData.phone;
        }

        if (this.filterData.deposit != null && this.filterData.deposit.id != "all") {
          data.parameters.deposit = this.filterData.deposit.id == "1" ? true : false;
        }

        if (this.filterData.buyer) {
          data.parameters.buyer_id = this.filterData.buyer.id;
        }

        if (this.filterData.team) {
          data.parameters.team_id = this.filterData.team.id;
        }

        if (this.filterData.status) {
          data.parameters.status_id = this.filterData.status.id;
        }

        if (this.filterData.created_at_from) {
          data.parameters.created_at_from = moment(this.filterData.created_at_from).format(
            "YYYY-MM-DD",
          );
        }

        if (this.filterData.created_at_to) {
          data.parameters.created_at_to = moment(this.filterData.created_at_to).format(
            "YYYY-MM-DD",
          );
        }
      }

      leadApi
        .getLeadJobsList(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          const leads = res.data.data;
          console.log(leads);
          for (let i = 0; leads.length > i; i++) {
            leads[i].deposit = leads[i].deposit && leads[i].deposit.deposit > 0 ? "Yes" : "No";
            leads[i].is_duplicate = leads[i].isDuplicate ? "Yes" : "No";
            leads[i].lead_id = leads[i].leadId;
            leads[i].client_id = leads[i].clientId;
            leads[i].distribution_id = leads[i].distributionId;
            leads[i].integration_id = leads[i].integrationId;
            leads[i].created_at = moment(leads[i].createdAt).format("DD.MM.YYYY HH:mm");
            leads[i].available_at = moment(leads[i].availableAt).format("DD.MM.YYYY HH:mm");
          }

          this.$store.commit("lead/setLeadsList", leads);
          this.$store.commit("lead/setLeads", res.data);
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    filterList() {
      this.isFilter = true;
      if (this.page > 1) {
        this.$router.push({
          path: ROUTE.LEAD_JOBS.replace(":page", 1),
        });
      } else {
        this.getList();
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.filterData.id = "";
      this.filterData.first_name = "";
      this.filterData.last_name = "";
      this.filterData.phone = "";
      this.filterData.campaign_internal = "";
      this.filterData.integration = null;
      this.filterData.country = null;
      this.filterData.status = null;
      this.filterData.created_at_from = null;
      this.filterData.created_at_to = null;
      this.filterData.email = "";
      this.filterData.languages = null;
      this.filterData.deposit = null;
      this.filterData.buyer = null;
      this.filterData.team = null;
      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("lead/setLoading", true);
      leadApi
        .deleteLead(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    handleEdit(row) {
      console.log(row);
    },
    getLogStatus() {
      leadApi
        .getLogStatus()
        .then((res) => {
          this.logStatus = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleDetail(row) {
      this.detailModal = true;
      this.chosenLead = this.leadsList.find((item) => item.id === row.id);

      if (row.id) {
        // const url = `?lead_id=${row.id}&integration_id=${row.integrationId}&with[0]=status&perPage=100`;
        const url = `?perPage=1000&page=1&sortField=log_created_at&sortDest=desc&entity_id=${row.id}`;

        leadApi
          .getLeadLog(url)
          .then((res) => {
            this.$store.commit("lead/setLoading", false);
            this.logList = res.data.data.map((item, index) => ({
              ...item,
              is_detail: false,
            }));
          })
          .catch((error) => {
            this.$store.commit("lead/setLoading", false);
            console.log(error);
          });
      }
    },
    exportLead() {
      this.$store.commit("lead/setLoading", true);

      const data = {
        parameters: {},
      };

      if (this.isFilter) {
        if (this.filterData.id.length) {
          data.parameters.id = this.filterData.id;
        }

        if (this.filterData.first_name.length) {
          data.parameters.first_name = this.filterData.first_name;
        }

        if (this.filterData.last_name.length) {
          data.parameters.last_name = this.filterData.last_name;
        }

        if (this.filterData.email.length) {
          data.parameters.email = this.filterData.email;
        }

        if (this.filterData.campaign_internal.length) {
          data.parameters.campaign_internal = this.filterData.campaign_internal;
        }

        if (this.filterData.integration) {
          data.parameters.integration_id = this.filterData.integration.id;
        }

        if (this.filterData.country) {
          data.parameters.country_id = this.filterData.country.id;
        }

        if (this.filterData.status) {
          data.parameters.status_id = this.filterData.status.id;
        }

        if (this.filterData.languages) {
          data.parameters.language_id = this.filterData.languages.id;
        }

        if (this.filterData.phone.length) {
          data.parameters.phone = this.filterData.phone;
        }

        if (this.filterData.deposit != "all" && this.filterData.deposit != null) {
          this.parameters.deposit = this.filterData.deposit.id;
        }

        if (this.filterData.buyer) {
          data.parameters.buyer_id = this.filterData.buyer.id;
        }

        if (this.filterData.team) {
          data.parameters.team_id = this.filterData.team.id;
        }

        if (this.filterData.created_at_from) {
          data.parameters.created_at_from = moment(this.filterData.created_at_from).format(
            "YYYY-MM-DD",
          );
        }

        if (this.filterData.created_at_to) {
          data.parameters.created_at_to = moment(this.filterData.created_at_to).format(
            "YYYY-MM-DD",
          );
        }
      }

      leadApi
        .exportLead(data)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },

    handleCloseDetailModal() {
      this.detailModal = false;
      this.chosenLead = null;
      this.logList = null;
      this.sendData.integration = null;
    },
    closeModal() {
      this.error = null;
    },
    handleLogDetail(index, data) {
      console.log(this.logList);
      this.logList[index].is_detail = data;
    },
    changePerPage(data) {
      this.perPage = data;
      this.getList();
    },
    reimport(data) {
      console.log(data);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.6fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.5fr 1.5fr 1.5fr !important;
}

/deep/.modal-container {
  max-width: 90vw !important;
  max-height: 90vh;
  height: fit-content;
  overflow-y: auto;
}

/deep/.delete .modal-container {
  max-width: none;
  max-height: none;
  width: fit-content;
  height: fit-content;
  overflow-y: auto;
}

/deep/.success .modal-container {
  max-width: 100% !important;
  width: 100%;
}

/deep/.delete .list__confirm {
  flex-direction: column;
}

/deep/.mx-datepicker {
  width: 100%;
}

.list {
  &__confirm {
    justify-content: flex-start;
    flex-direction: row;
  }

  &__confirm-column {
    width: 50%;
    padding: 0 10px;
  }

  &__confirm-title {
    padding: 0 0 30px;
    font-weight: 700;
    text-align: left;
  }

  &__modal-list-item {
    padding-bottom: 10px;
    font-size: 18px;
    word-wrap: break-word;
  }

  &__modal-log {
    padding: 10px;
    background: gainsboro;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  &__modal-log-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__modal-log-date {
    font-size: 12px;
  }

  &__modal-log-status {
    font-size: 12px;
  }

  &__modal-log-type {
    padding: 5px;
    background: rgb(255, 255, 255);
    border-radius: 10px;
    width: fit-content;
    font-size: 12px;
  }

  &__modal-log-integration {
    font-size: 12px;
    padding: 5px;
    word-break: break-all;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 150px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }

  &__modal-sent-title {
    padding: 10px 0;
    font-weight: 700;
  }

  &__modal-sent-button {
    padding-top: 10px;
  }

  &__per-page {
    display: flex;
    padding-right: 50px;
  }

  &__per-page-item {
    padding: 7px;
    background: rgb(136, 136, 136);
    color: #fff;
    border-radius: 5px;
    margin-right: 5px;
    font-weight: 700;
    cursor: pointer;

    &.active {
      background: #3c2a1e;
    }
  }
}
.pagination {
  display: flex;
  align-items: center;
}
</style>
